<script setup>
import { ref } from 'vue';
import { Head, Link, router } from '@inertiajs/vue3';
import Banner from '@/Components/Banner.vue';
import Header from '@/Components/Header.vue';
import NewFooter from '@/Components/NewFooter.vue';
import NewNavbar from '@/Components/Navs/NewNavbar.vue';
import SGGuestNavbar from '@/Components/Navs/SgGuestNavbar.vue';

defineProps({
    title: String
});

const showingNavigationDropdown = ref(false);

const switchToTeam = team => {
    router.put(
        route('current-team.update'),
        {
            team_id: team.id
        },
        {
            preserveState: false
        }
    );
};

const logout = () => {
    router.post(route('logout'));
};
</script>

<template>
    <div>

        <Head :title="title" />

        <SGGuestNavbar />
        <Banner />
        <!-- <Header></Header> -->
        <!-- <NewNavbar /> -->

        <div class="min-h-screen bg-gray-100">
            <!-- Page Heading -->
            <header v-if="$slots.header" class="bg-gray-800 shadow text-gray-50">
                <div class="px-4 py-6 mx-auto max-w-7xl sm:px-6 lg:px-8">
                    <slot name="header" />
                </div>
            </header>

            <!-- Page Content -->
            <main class="mx-auto">
                <slot />
            </main>
            <NewFooter />
        </div>
    </div>
</template>

<style scoped>
a {
    color: black !important;
}
</style>
